"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMapDimensions = exports.textDimensions = void 0;
const canvas_1 = require("canvas");
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("./constants");
const canvas = (0, canvas_1.createCanvas)(0, 0);
const canvasContext = canvas.getContext('2d');
const handleRotation = (w, h, rotation) => {
  const dr = Math.PI / 180;
  const s = Math.sin(rotation * dr);
  const c = Math.cos(rotation * dr);
  const points = [];
  for (let i = -1; i < 2; i += 2) {
    for (let j = -1; j < 2; j += 2) {
      const px = w * i / 2;
      const py = h * j / 2;
      const nx = px * c - py * s;
      const ny = px * s + py * c;
      points.push({
        x: nx,
        y: ny
      });
    }
  }
  const xPoints = points.map(_ref => {
    let {
      x
    } = _ref;
    return x;
  });
  const yPoints = points.map(_ref2 => {
    let {
      y
    } = _ref2;
    return y;
  });
  const width = Math.abs(lodash_1.default.min(xPoints)) + Math.abs(lodash_1.default.max(xPoints));
  const height = Math.abs(lodash_1.default.min(yPoints)) + Math.abs(lodash_1.default.max(yPoints));
  return {
    width,
    height
  };
};
const textDimensions = _ref3 => {
  let {
    text,
    fontSize = constants_1.DEFAULT_FONT_SIZE,
    fontFamily = constants_1.FONT_FAMILY,
    rotateDegrees = 0
  } = _ref3;
  if (lodash_1.default.isNil(text)) {
    return {
      width: 0,
      height: 0
    };
  }
  canvasContext.font = `${fontSize}px ${fontFamily}`;
  const {
    actualBoundingBoxLeft,
    actualBoundingBoxRight,
    actualBoundingBoxAscent,
    actualBoundingBoxDescent,
    fontBoundingBoxAscent,
    fontBoundingBoxDescent
  } = canvasContext.measureText(text);
  const width = actualBoundingBoxLeft + actualBoundingBoxRight;
  const height = (fontBoundingBoxAscent ?? actualBoundingBoxAscent) + (fontBoundingBoxDescent ?? actualBoundingBoxDescent);
  if (rotateDegrees) {
    return handleRotation(width, height, rotateDegrees);
  }
  return {
    width,
    height
  };
};
exports.textDimensions = textDimensions;
const getMapDimensions = function (ratio) {
  let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  let height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  if (!width && !height) {
    return {
      height: 0,
      width: 0
    };
  }
  let nWidth;
  let nHeight;
  if (width) {
    nWidth = width;
    nHeight = nWidth / ratio;
    if (height && nHeight > height) {
      nHeight = height;
      nWidth = nHeight * ratio;
    }
  } else {
    nHeight = height;
    nWidth = height * ratio;
    if (width && nWidth > width) {
      nWidth = width;
      nHeight = nWidth / ratio;
    }
  }
  return {
    width: Math.round(nWidth) || 0,
    height: Math.round(nHeight) || 0
  };
};
exports.getMapDimensions = getMapDimensions;